import React, { useState } from "react";
import { getProjects } from "../api/projects";
import { ProjectsTypes } from "../interfaces/ProjectsTypes";
import { USER_DATA } from "../utils/constants";
import { createContext } from "react";

type UserContextType = {
  projects: ProjectsTypes[] | undefined;
  setProjects: React.Dispatch<
    React.SetStateAction<ProjectsTypes[] | undefined>
  >;
  // transform to promise
  getUserProjects: () => Promise<void>;
};

const iUserContextState: UserContextType = {
  projects: [],
  setProjects: () => {},
  getUserProjects: () => new Promise((resolve) => {}),
};

export const ProjectsContext =
  createContext<UserContextType>(iUserContextState);

export default function ProjectsProvider(props: any) {
  const [projects, setProjects] = useState<ProjectsTypes[]>();

  async function getUserProjects(): Promise<void> {
    const userDataStorage = JSON.parse(localStorage.getItem(USER_DATA) || "{}");

    const response = await getProjects(userDataStorage.uid);
    setProjects(response);
  }

  return (
    <ProjectsContext.Provider
      value={{
        projects,
        setProjects,
        getUserProjects,
      }}
    >
      {props.children}
    </ProjectsContext.Provider>
  );
}
